import { Component, OnInit, Input } from '@angular/core';
import { ALERT_TYPES, Alert } from '@edassist/shared';
import { FORM_ERROR_ALERT_MESSAGES } from './form-error-alert.constants';
import { FormComponent } from '../form/form.component';

@Component({
	selector: 'ea-form-error-alert',
	templateUrl: './form-error-alert.component.html'
})
export class FormErrorAlertComponent implements OnInit {
	@Input() formErrorMessage = FORM_ERROR_ALERT_MESSAGES.defaultErrorMessage;
	@Input() form?: FormComponent;
	formErrorAlert: Alert;

	ngOnInit(): void {
		this.formErrorAlert = new Alert(ALERT_TYPES.Error, this.formErrorMessage);
	}
}
